import { ASSIGNED_ADVISOR_LOOKUP_KINDS } from 'cpool-constants';
import { z } from 'zod';

import { UsersTableDefinitionZod } from '../../tables';

export const schemaAssignedAdvisorFound = z.object({
    advisor: UsersTableDefinitionZod.pick({ absence: true, firstName: true, gender: true, id: true, lastName: true }),
    kind: z.literal(ASSIGNED_ADVISOR_LOOKUP_KINDS.FOUND),
});

export const schemaAssignedAdvisorNone = z.object({ kind: z.literal(ASSIGNED_ADVISOR_LOOKUP_KINDS.NONE) });
